import cssVars from "css-vars-ponyfill";
import smoothscroll from "smoothscroll-polyfill";

export default function () {
	cssVars();
	smoothscroll.polyfill();

	if (!("remove" in Element.prototype)) {
		Element.prototype.remove = function () {
			if (this.parentNode) {
				this.parentNode.removeChild(this);
			}
		};
	}

	if (!NodeList.prototype.forEach) {
		NodeList.prototype.forEach = Array.prototype.forEach;
	}
}
